import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesSchemesAssociateRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-schemes-associate',
	path: '/secure/admin/AssociateIssueTypeSchemes!default.jspa',
};
